'use strict';

module.exports = ['$scope', '$location', '$window', '$http', 'OrderSvc', 'MaterialSvc', '$rootScope', 'PlantSvc', function ($scope, $location, $window, $http, OrderSvc, MaterialSvc, $rootScope, PlantSvc) {
    // ------------------
    // Initialization
    // ------------------

    $scope.orders = [];
    $scope.quantityList = [];
    $scope.currentPage = $location.search().page || 1;
    $scope.totalPages = 0;
    $scope.pageSize = 15;
    $scope.sort_by = $location.search().sort_by;
    $scope.sort_order = $location.search().sort_order;
    $scope.maxVisiblePages = 7;
    $scope.filtersActive = false;
    $scope.customFieldsListActive = false;
    $scope.full_text = $location.search().full_text || "";
    $scope.quantity_from = $location.search().quantity_from || "";
    $scope.quantity_to = $location.search().quantity_to || "";
    $scope.date_to = $location.search().date_to ? new Date($location.search().date_to) : null;
    $scope.date_from = $location.search().date_from ? new Date($location.search().date_from) : null;
    $scope.customFields = {};
    // helper functions

    // ------------------
    var loadOrders = function () {
        OrderSvc.list($rootScope.plant, {
            page_size: $scope.pageSize,
            page: $scope.currentPage,
            sort_by: $scope.sort_by,
            sort_order: $scope.sort_order,
            filters: {
                full_text: $scope.full_text,
                quantity_to: $scope.quantity_to,
                quantity_from: $scope.quantity_from,
                date_to: $scope.formatDate($scope.date_to),
                date_from: $scope.formatDate($scope.date_from)
            }
        }).success(function (data) {
            $scope.orders = data.results.map((order) => {
                order.customFields = {};
                order.order.extra_fields_data.forEach(field => {
                    order.customFields[field.key] = field.value
                });
                return order;
            })

            $scope.totalItems = data.count;
            $scope.totalPages = Math.ceil(data.count / $scope.pageSize);
        });

    };

    var getCustomFields = function () {
        PlantSvc.getOrderFields($rootScope.plant).success(function (data) {
            const queryStringMap = $location.search()
            data.reduce((map, field) => {
                $scope.customFields[field.name] = queryStringMap[field.name] || false, {}
            })
        })
    }

    var getQuantitiesList = function () {
        OrderSvc.quantityList($rootScope.plant).success(function (data) {
            $scope.quantityList = data.quantities;
            $scope.quantity_to = parseInt($location.search().quantity_to, 10);
            $scope.quantity_from = parseInt($location.search().quantity_from, 10);
            loadOrders();
        });
    }

    $scope.formatDate = function (date) {
        if (date) {
            return date.toISOString().substring(0, 10);
        } else {
            return null;
        }
    }

    // ------------------
    // Scope Functions
    // ------------------
    $scope.changePage = function (page) {
        $location.search('page', page);
    };

    $scope.filter = function (event) {
        if (event.which === 13) {
            $location.search('page', 1);
            $location.search('full_text', $scope.full_text);
        }
    }

    $scope.customFieldChanged = function (key) {
        $location.search(key, ($scope.customFields[key] ? true : null));
    }

    $scope.filterChanged = function (key) {
        $location.search('page', 1);
        $location.search(key, $scope[key]);
        loadOrders()
    }

    $scope.sort = function (sort_by) {
        $location.search('sort_by', sort_by);

        if ($scope.sort_by == sort_by) {
            var sort_order = $scope.sort_order == 'asc' ? 'desc' : 'asc';
            $location.search('sort_order', sort_order);
        } else {
            $location.search('sort_order', 'asc');
        }
    };

    $scope.toggleFilters = function () {
        $scope.filtersActive = !$scope.filtersActive;
    }

    $scope.toggleCustomFieldsList = function () {
        $scope.customFieldsListActive = !$scope.customFieldsListActive;
    }

    // ------------------
    // EVENTS

    // ------------------
    $scope.$on('refresh-signal', loadOrders);

    $scope.$on('$locationChangeSuccess', function () {
        if ($location.search().page) {
            $scope.currentPage = $location.search().page;
            loadOrders();
        }
        if ($location.search().sort_order) {
            $scope.sort_order = $location.search().sort_order;
        }
        if ($location.search().sort_by) {
            $scope.sort_by = $location.search().sort_by;
        }
        if ($location.search().full_text) {
            $scope.full_text = $location.search().full_text;
        }
        if ($location.search().quantity_to) {
            $scope.quantity_to = parseInt($location.search().quantity_to, 10);
        }
        if ($location.search().quantity_from) {
            $scope.quantity_from = parseInt($location.search().quantity_from, 10);
        }
        if ($location.search().date_from) {
            $scope.date_from = new Date($location.search().date_from);
        }
        if ($location.search().date_to) {
            $scope.date_to = new Date($location.search().date_to);
        }
    });

    // ------------------
    // WATCHES
    // ------------------
    $scope.$watchCollection('[sort_order, sort_by]', function (newval, oldval) {
        if (newval != oldval) {
            loadOrders();
        }
    });

    // ------------------
    // Load Dependent Data
    // ------------------

    getQuantitiesList();
    getCustomFields();
    loadOrders();

}];